import React from 'react';

interface ProfileIconWithInitialsProps {
  name: string;
  size?: number;
  fontSize?: number;
  style?: React.CSSProperties;
}

const ProfileIconWithInitials: React.FC<ProfileIconWithInitialsProps> = ({ 
  name, 
  size = 30, 
  fontSize = 14,
  style
}) => {
  const initials = name? name.split(' ').map(word => word[0]).join('').toUpperCase().slice(0, 2): '?';

  return (
    <div style={{
      width: `${size}px`,
      height: `${size}px`,
      position: 'relative',
      ...style
    }}>
      <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="20" cy="20" r="15.5" fill="#bfc4ff" stroke="#bfc4ff"/>
      </svg>
      <div style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        fontSize: `${fontSize}px`,
        fontWeight: 'bold',
        color: '#1c2a61'
      }}>
        {initials}
      </div>
    </div>
  );
};

export default ProfileIconWithInitials;